<template>
  <CategoryProductsList
    :category="category"
    :products="products"
    :is-loading="products == null"
    link-from-param="main-page"
    :link-from-value="category.id"
  />
</template>

<script setup lang="ts">
  import { Category } from '@/api/requests/CategoriesList';
  import { getCategoryProducts } from '@/services/product/api';
  import { Product } from '@/services/product/types';
  import { ref, onMounted } from 'vue';
  import CategoryProductsList from '../catalog/CategoryProductsList.vue';

  const props = defineProps<{
    category: Category;
  }>();

  const products = ref<Product[] | null>(null);

  onMounted(() => {
    getCategoryProducts(props.category.id.toString()).then(response => {
      products.value = response.data;
    });
  });
</script>
